module.exports = __webpack_public_path__ + "static/media/about_us_owner_neysa.11ce95fd.jpg";